import { render, staticRenderFns } from "./right-chart.vue?vue&type=template&id=0dc682b6&scoped=true&"
import script from "./right-chart.vue?vue&type=script&lang=js&"
export * from "./right-chart.vue?vue&type=script&lang=js&"
import style0 from "./right-chart.vue?vue&type=style&index=0&id=0dc682b6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc682b6",
  null
  
)

export default component.exports